import type { IconSvgObject } from './types';

const Dish02Icon: IconSvgObject = [
  ["path", { d: "M21 17C18.2386 17 16 14.7614 16 12C16 9.23858 18.2386 7 21 7", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 21C16.0294 21 12 16.9706 12 12C12 7.02944 16.0294 3 21 3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 3L6 8M6 21L6 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3.5 8H8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M9 3L9 7.35224C9 12.216 3 12.2159 3 7.35207L3 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default Dish02Icon;
